module.exports = __webpack_public_path__ + "static/media/saastot.17b360fb.svg";